import { render, staticRenderFns } from "./TabCard.vue?vue&type=template&id=55a4271c&scoped=true&"
import script from "./TabCard.vue?vue&type=script&lang=js&"
export * from "./TabCard.vue?vue&type=script&lang=js&"
import style0 from "./TabCard.vue?vue&type=style&index=0&id=55a4271c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a4271c",
  null
  
)

export default component.exports